import { useEffect } from "react";
import { Row } from "react-bootstrap";
import CardComp from "./CardComp";
import PaginationComp from "./PaginationComp";
import { useDispatch, useSelector } from "react-redux";
import { getAllMovies } from "../Redux/actions";
const MoveList = () => {
  // To get the movies from the API
  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllMovies());
  }, []);
  // Render all movies during the mounting of the app
  let movies = useSelector((state) => state.data);
  return (
    <Row className="mt-5 justify-content-center">
      {movies.length > 0 ? (
        movies.map((movie) => {
          return <CardComp key={movie.id} movie={movie} />;
        })
      ) : (
        <h1 className="text-center">لايوجد أفلام</h1>
      )}
      {movies.length > 0 ? <PaginationComp /> : null}
    </Row>
  );
};

export default MoveList;
